"use client"

import { useEffect } from "react"
import { useTranslations, useLocale } from 'next-intl'
import HeaderPage from "@/components/header-page"
import StateCard from "@/components/state-card"
import { useStateSharedData } from "@/app/store/useStateSharedData"

export default function StatesClient() {
  const t = useTranslations()
  const locale = useLocale()
  const { states, loading, error, fetchStates } = useStateSharedData()

  useEffect(() => {
    fetchStates()
  }, [])

  return (
    <div dir={locale === 'ar' ? 'rtl' : 'ltr'}>
      {/* Header with Breadcrumbs */}
      <HeaderPage
        title={t('navigation.states')}
        breadcrumbs={[
          { label: t('common.home'), href: "/" },
          { label: t('navigation.states') }
        ]}
      />

      <div className="p-4">

        {/* Error */}
        {error && <p>{t('common.error')}</p>}

        {/* Loading Skeleton */}
        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 gap-6">
            {[...Array(10)].map((_, i) => (
              <div key={i} className="flex flex-col bg-gray-300 shadow rounded-3xl overflow-hidden animate-pulse">
                
                {/* Image placeholder */}
                <div className="h-64 w-full bg-gray-300"></div>

                {/* Rotated text placeholder */}
                <div className="p-4 flex justify-start items-start">
                  <div className={locale === 'ar' ? 'rotate-90' : '-rotate-90'}>
                    <div className="h-4 w-20 bg-gray-300 rounded"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          /* Real Cards */
          <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 gap-6">
            {states.map((destination: any) => (
              <StateCard
                key={destination.id}
                item={destination}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
